.firstScreenWrapper {
  background: #fffbf1;
  position: relative;
}

.firstScreenWrapperV2 {
  background: #fffbf1;
  padding-top: 60px;
}

.timerWrapper {
  position: sticky;
  top: 0;
  z-index: 5;
}

.timerWrapperTop {
  position: sticky;
  top: 0;
  z-index: 2;
  margin-bottom: 8px;
}

.timerWrapperPuppy {
  position: sticky;
  top: 0;
  z-index: 2;
}

.timerWrapperV2 {
  position: sticky;
  top: 0;
  z-index: 2;
}

.barChartWrapper {
  margin-top: 18px;
  padding: 0 20px;
}

.benefitsWrapper {
  margin-top: 32px;
  padding: 0 20px;
}

.trainingProfileWrapper {
  margin-top: 32px;
}

.freeBonusMainBlockWrapper {
  padding: 0 20px;
  margin-bottom: 32px;
  margin-top: 48px;
}

.offerWrapper {
  margin-top: 32px;
  // Offset for the sticky timer when the "Get my plan" button scrolls here.
  scroll-margin-top: 55px;
}

.offerWrapper2 {
  margin-top: 0px;
}

.polycyWrapper {
  padding: 0 20px;
  margin-top: 20px;
}

.getMyplanWrapper {
  margin-top: 12px;
}

.getMyplanWrapper2 {
  margin-top: 12px;
}

.supportBlockWrapper {
  margin-top: -32px;
  padding: 0 20px;
  margin-bottom: 32px;
}

.ReviewsSliderWrapper {
  margin-top: 32px;
  overflow: hidden;
}

.imgWrapper {
  margin-top: 32px;
}

.infoBlockWrappre {
  margin-top: 50px;
  margin-bottom: 50px;
}

.secondScreenWrapper {
  padding-top: 32px;
  background: #00a36f;
  position: relative;
}

.informationWrapper {
  padding: 0 20px;
  margin-top: 8px;
  margin-bottom: 32px;
}

.guaranteeWrapper {
  padding: 0 20px;
  margin-top: 32px;
  margin-bottom: 84px;
}

.moneyBackWrapper {
  width: 100%;
  margin-top: 12px;
}